import store from '@/store';

class Depot {
  static current() {
    const depots = store.getters['app/depots'];
    const currentDepotID = store.getters['order/currentDepot'];
    return depots.find(depot => depot.id === currentDepotID);
  }

  static gates(depotId = null) {
    const depots = store.getters['app/depots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot.id === currentDepotID);
    return currentDepot.gates;
  }

  static depot(depotId = null) {
    const depots = store.getters['app/depots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot.id === currentDepotID);
    return currentDepot;
  }
  
  static vendor(depotId = null) {
    const vendorDepots = store.getters['app/vendorDepots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = vendorDepots.find(depot => depot.id === currentDepotID);
    return currentDepot;
  }
  static depotOthers(depotId = null) {
    const depots = store.getters['app/otherDepots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot.id === currentDepotID);
    return currentDepot;
  }

  static otherGate(gateId, depotId = null) {
    const depots = store.getters['app/otherDepots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot.id === currentDepotID);
    return currentDepot ? currentDepot.gates.find(gate => gate.id === gateId) : {};
  }

  static docks(depotId = null) {
    const depots = store.getters['app/depots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot.id === currentDepotID);
    return currentDepot.docks;
  }

  static otherDocks(dockId, depotId = null) {
    const depots = store.getters['app/otherDepots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot.id === currentDepotID);
    return currentDepot.docks.find(dock => dock.id === dockId);
  }

  static getById(depotId) {
    const depots = store.getters['app/depots'];
    return depots.find(depot => depot.id === depotId);
  }

  static gate(gateId, depotId = null) {
    const depots = store.getters['app/depots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot.id === currentDepotID);
    return currentDepot && currentDepot.gates.find(gate => gate.id === gateId);
  }

  static dock(dockId, depotId) {
    const depots = store.getters['app/depots'] || [];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot && depot.id === currentDepotID);

    if (!currentDepot || !Array.isArray(currentDepot.docks)) {
      return null;
    }

    return currentDepot.docks.find(dock => dock && dock.id === dockId);
  }

  static docksByGate(gateId, depotId) {
    const depots = store.getters['app/depots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot.id === currentDepotID);
    return (currentDepot && currentDepot.docks) ?
      currentDepot.docks.filter(dock => dock.gate_ids.includes(gateId)) : [];
  }

  static hasDocks(gateId, depotId = null) {
    const depots = depotId || store.getters['app/depots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot.id === currentDepotID);
    return currentDepot.docks && currentDepot.docks.length !== 0;
  }

  static gatesHasDocks(gateIds = [], depotId = null) {
    const depots = depotId || store.getters['app/depots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot.id === currentDepotID);
    if (!currentDepot || !(currentDepot.docks && currentDepot.docks.length)) {
      return false;
    }
    return gateIds.some(gateId => currentDepot.docks.find(dock => dock.gate_ids.includes(gateId)));
  }

  static gateHasDocks(gateId, depotId = null) {
    const depots = depotId || store.getters['app/depots'];
    const currentDepotID = depotId || store.getters['order/currentDepot'];
    const currentDepot = depots.find(depot => depot.id === currentDepotID);
    if (!currentDepot || !(currentDepot.docks && currentDepot.docks.length)) {
      return false;
    }
    return currentDepot.docks.some(dock => dock.gate_ids.includes(gateId));
  }
}

export default Depot;
